import React from 'react';
import { ChatsStatus } from './Statuses';
import { DashboardHeader } from './Header';
import { ChatsConclusoesMes } from './ConclusoesMes';
import { ChatsFaturamentoMes } from './FaturamentoMes';
import { ChartVisaoGeral } from './VisaoGeral';

export const StaticDashboard = () => {
    return (
        <div className="flex flex-col gap-6 pb-4">
            <DashboardHeader />

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <div className="card sf-dashboard-panel">
                    <div className="card-body">
                        <div className="mb-2">
                            <h3 className="text-lg font-semibold text-base-content">Concluídos no mês</h3>
                            <p className="text-sm text-base-content/60">Volume diário da competência selecionada.</p>
                        </div>
                        <div className="min-h-[350px]">
                            <ChatsConclusoesMes />
                        </div>
                    </div>
                </div>
                <div className="card sf-dashboard-panel">
                    <div className="card-body">
                        <div className="mb-2">
                            <h3 className="text-lg font-semibold text-base-content">Faturamento no mês</h3>
                            <p className="text-sm text-base-content/60">Receita e comissão ao longo da competência.</p>
                        </div>
                        <div className="min-h-[350px]">
                            <ChatsFaturamentoMes />
                        </div>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
                <div className="card sf-dashboard-panel">
                    <div className="card-body">
                        <ChartVisaoGeral />
                    </div>
                </div>
                <div className="card sf-dashboard-panel">
                    <div className="card-body">
                        <ChatsStatus />
                    </div>
                </div>
            </div>
        </div>
    );
};
